module.exports = __webpack_public_path__ + "assets/img/544f-km.svg";